module.exports = __webpack_public_path__ + "static/media/oval.9b35600a.svg";